import styled from "styled-components";
import { colors } from "../../../../../theme/theme";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    border-radius: 4px;
    padding: 30px;
    padding-bottom: 5px;
    padding-top: 20px;

    @media only screen and (max-width: 1200px) { 
        max-width: 900px;
    }

`

export const Filters = styled.div`
    display: flex;
    justify-content:space-between;
`

export const DashboardSelect = styled.div`
    max-width: 200px;
    margin-right: 5px;
   
    select  { 
        color: ${colors.mainColors.blueberry};
        border: 1px solid ${colors.mainColors.blueberry};
        cursor: pointer;
    }
    
`;